import { Box, Modal, Typography } from '@mui/material';
import { NotificationText } from '@/data/context/notifications';
import ClearIcon from '@mui/icons-material/Clear';
import {
	NotificationsModalButtonSX,
	NotificationsModalContentSX,
	NotificationsModalFrameSX,
	NotificationsModalHeaderFrameSX,
	NotificationsModalHeaderIconSX,
	NotificationsModalMessageSX,
	NotificationsModalTitleSX,
} from '@/components/content/Notifications/styles/modal';
import { useNextRouter } from '@/data/Content/_NextRouter';
import { useLocalization } from '@/data/Localization';
import { useState } from 'react';
import { DpButton } from '@/components/blocks/DpLibrary/DpButton';

interface SessionExpiredModalProps {
	id: string;
	title?: NotificationText;
	message?: NotificationText;
	mobile: boolean;
	// onClear: () => void;
}

export const SessionExpiredModal: React.FC<SessionExpiredModalProps> = ({
	id,
	title,
	message,
	mobile,
	// onClear,
}) => {
	const router = useNextRouter();
	const RouteLocal = useLocalization('Routes');

	const [closeModal, setCloseModal] = useState<boolean>(false);

	const handleClose = () => {
		setCloseModal(true);
	};

	const handleLoginClick = () => {
		router.push(`/${RouteLocal.Login.route.t()}`);
		handleClose();
	};

	const handleStoreClick = () => {
		if (router.asPath.includes('/cuenta')) {
			router.push('/');
			handleClose();
		} else if (router.asPath.includes('/finalizar-la-compra')) {
			router.push(`/${RouteLocal.Cart.route.t()}`);
			handleClose();
		} else {
			handleClose();
		}
	};

	return (
		<Modal
			open={!closeModal}
			aria-labelledby={id}
			aria-describedby={`${id}-description`}
			// onClose={onClear}
		>
			<Box sx={NotificationsModalFrameSX(mobile)}>
				<Box sx={NotificationsModalHeaderFrameSX(mobile)}>
					<ClearIcon sx={NotificationsModalHeaderIconSX} onClick={handleClose} />
				</Box>
				<Box sx={NotificationsModalContentSX(mobile)}>
					{title ? (
						<Typography id={id} sx={NotificationsModalTitleSX(mobile)}>
							{title}
						</Typography>
					) : null}
					<Typography id={`${id}-description`} sx={NotificationsModalMessageSX}>
						{message}
					</Typography>

					<Box
						sx={{
							display: 'flex',
							flexDirection: {
								xs: 'column',
								sm: 'row',
							},
							gap: 2,
							mt: 2,
							width: '100%',
						}}
					>
						<DpButton sx={NotificationsModalButtonSX} onClick={handleLoginClick}>
							{'Iniciar sesión'}
						</DpButton>
						<DpButton sx={NotificationsModalButtonSX} onClick={handleStoreClick}>
							{'Ir a la tienda'}
						</DpButton>
					</Box>
				</Box>
			</Box>
		</Modal>
	);
};
